import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ApiService from "../../services/ApiService";
import { useAppContext } from "../../context/AppContext";
import Loader from "../../components/loader";
import { getOrCreateDeviceId } from "../../utils/deviceId";
// import { getPurchaseOrder } from "../../utils/purchaseOrder";
// import { getApiToken } from "../../utils/apiToken";
import Toast from "../../components/Toast";
const VendorAccess: React.FC = () => {
  const {
    setPhotos,
    token,
    setToken,
    setDelivery,
    purchaseOrder,
    setPurchaseOrder,
    setLoads,
    setAttachments,
    setLoadItems, 
    setMaterialfo,
    setSalesOrder,
    setProgressDeliveries,
    setMeterialSo,
  } = useAppContext();

  const navigate = useNavigate();
  const [hasFetched, setHasFetched] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [confirmPin, setCofirmPin] = useState("");
  const [vendorToken, setVendorToken] = useState<string | null>(null);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [toast, setToast] = useState<{
    message: string;
    type: "success" | "error";
    duration?: number;
  } | null>(null);

  useEffect(() => {
    if (!hasFetched && !(purchaseOrder && token)) {
      setHasFetched(true);
      getDataThroughVendorToken();
    }
    if (purchaseOrder && token) {
      navigate(`/`);
    }
  }, [purchaseOrder, token, hasFetched, navigate]);

  const getDataThroughVendorToken = async () => {
    try {
      const params = new URLSearchParams(window.location.search);
      const token = params.get("token");

      if (!token) {
        setToast({ message: "Token is missing from the URL", type: "error" });
        throw new Error("Token is missing from the URL");
      }

      setVendorToken(token);
      
      // Get or create device ID for remember device feature
      const deviceId = getOrCreateDeviceId();
      
      let responseData = null;

      try {
        responseData = await ApiService.verifyVendorToken(token, deviceId);
      } catch (error: any) {
        setToast({
          message: "API Request Faild",
          type: "error",
        });
        throw new Error(error.message || "API Request Faild");
      }

      if (!responseData.success) {
        setToast({
          message: "Server Error: Token Verification Failed",
          type: "error",
        });
      }

      if (responseData && responseData.success) {
        // Check if device is already verified (skip PIN requirement)
        // When device is verified, backend returns full data structure (same as verifyPin)
        // If purchase_order exists in data, it means device was verified and full data was returned
        if (responseData.data?.purchase_order) {
          // Device is verified, full data was returned automatically
          setToast({
            message: "Device recognized. Access granted.",
            type: "success",
          });
          
          // Full data was returned, set it up
          setPurchaseOrder(responseData.data.purchase_order);
          setToken(responseData.api_token);
          setDelivery(responseData.data.delivery);
          setLoads(responseData.data.loads);
          setLoadItems(responseData.data.item_loads);
          setPhotos(responseData.data.photos || []);
          setAttachments(responseData.data.attachments || []);
          setSalesOrder(responseData.data.sales_order);
          setMeterialSo(responseData.data.meterial_so);
          setMaterialfo(responseData.data.material_fo);
          setProgressDeliveries(responseData.data.progress);
          localStorage.setItem("_token", responseData.api_token);
          localStorage.setItem("page", "index");
          localStorage.setItem("vendor_token", token);
          localStorage.setItem("sales_order_id", responseData.data.sales_order.id);
          localStorage.setItem("zoho_sales_order_id", responseData.data.vendor.zoho_sales_order_id);
          localStorage.setItem("vendor_id", responseData.data.vendor.vendor_id);
          if (responseData.data.delivery) {
            localStorage.setItem("delivery_id", responseData.data.delivery.id || "");
            if (responseData.data.delivery.status == "open") {
              navigate(`/`);
            } else if (responseData.data.delivery.status == "assigned") {
              navigate(`/pick-up`);
            } else if (responseData.data.delivery.status == "picked_up") {
              navigate(`/upload-weight-ticket`);
            } else if (responseData.data.delivery.status == "reached") {
              navigate("/proof-of-dump-meterial");
            }
          } else {
            navigate(`/`);
          }
          return;
        }
        
        setToast({
          message: responseData.message || "Token Verified Successfully",
          type: "success",
        });
        let page = localStorage.getItem("page");
        let storageVendorToken = localStorage.getItem("vendor_token");

      
        
        if (storageVendorToken === token && page) { 
          const routes = [
            "index",
            "pick-up",
            "upload-weight-ticket",
            "jobsite",
            "proof-of-dump-meterial",
            "digital-signature",
            "complete-delivery",
          ];

          if(routes.includes(page)){ 
            navigate(page === 'index' ? '/' : `/${page}`);
            return;
          }
        }

        setShowModal(true);
      }
    } catch (error: any) {
      setLoading(true);
      setToast({
        message: "Server Error: Failed to Fetch Order Data",
        type: "error",
      });
      console.error("Error fetching order Data:", error);
    } finally {
      setLoading(false);
    }
  };

  const ConfirmPinSubmit = async () => {
    if (confirmPin === "") {
      setToast({ message: "Please Enter Pin to Proceed!", type: "error" });
      return true;
    }

    setButtonLoading(true);

    if (!vendorToken) {
      setToast({ message: "Vendor Token is Not Available", type: "error" });
    }

    // Get device ID for remember device feature
    const deviceId = getOrCreateDeviceId();

    let responseData = null;
    try {
      responseData = await ApiService.verifyPin({
        vendorToken: vendorToken,
        confirm_pin: confirmPin,
        token: false,
        device_id: deviceId, // Send device_id to store verification
      });
    } catch (error: any) {
      setToast({
        message: "Confirm Pin API Request Failed",
        type: "error",
      });
      throw new Error(error.message || "Confirm Pin API Request Failed");
    }

    if (responseData.success) {
      if (responseData?.cancelled) {
        setToast({ message: "This Order has been Cancelled.", type: "error" });
        setButtonLoading(false);
        localStorage.clear();
        return;
      }
      console.log("responseData", responseData);
      // setPurchaseOrder(responseData.data);
      setToast({
        message: "Your Pin Confirmed Successfully.",
        type: "success",
      });
      setPurchaseOrder(responseData.data.purchase_order);
      setToken(responseData.api_token);
      setDelivery(responseData.data.delivery);
      setLoads(responseData.data.loads);
      setLoadItems(responseData.data.item_loads);
      setPhotos(responseData.data.photos || []);
      setAttachments(responseData.data.attachments || []);
      setSalesOrder(responseData.data.sales_order);
      setMeterialSo(responseData.data.meterial_so);
      setMaterialfo(responseData.data.material_fo);
      setProgressDeliveries(responseData.data.progress);
      localStorage.setItem("_token", responseData.api_token);

      localStorage.setItem("page", "index");

      localStorage.setItem("vendor_token", vendorToken || "");

      localStorage.setItem("sales_order_id", responseData.data.sales_order.id);
      localStorage.setItem(
        "zoho_sales_order_id",
        responseData.data.vendor.zoho_sales_order_id
      );
      localStorage.setItem("vendor_id", responseData.data.vendor.vendor_id);
      if (responseData.data.delivery) {
        localStorage.setItem(
          "delivery_id",
          responseData.data.delivery.id || ""
        );

        if (responseData.data.delivery.status === "open") {
          navigate(`/`);
        } else if (responseData.data.delivery.status === "assigned") {
          navigate(`/pick-up`);
        } else if (responseData.data.delivery.status === "picked_up") {
          navigate(`/upload-weight-ticket`);
        } else if (responseData.data.delivery.status === "reached") {
          navigate("/proof-of-dump-meterial");
        }
      } else {
        navigate(`/`);
      }
    } else {
      // Make link expired errors permanent (duration: 0)
      const isExpiredError = responseData.message?.toLowerCase().includes('expired');
      setToast({ 
        message: responseData.message, 
        type: "error",
        duration: isExpiredError ? 0 : undefined 
      });

      setButtonLoading(false);
    }
  };

  if (loading) return <Loader />;

  return (
    <>
      {showModal && (
        <div className="custom-backdrop">
          <div className="custom-modal">
            <div className="custom-modal-header">
              <h5>Enter pin to start The delivery</h5>
            </div>
            <div className="custom-modal-body">
              <input
                type="text"
                className="form-control pinInput"
                onChange={(e) => setCofirmPin(e.target.value)}
                placeholder="Confirm Pin"
              />
            </div>
            <div className="custom-modal-footer">
              <button
                disabled={buttonLoading}
                className="btn-orange"
                onClick={() => ConfirmPinSubmit()}
              >
                {buttonLoading && (
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                )}
                Submit
              </button>
            </div>
          </div>
        </div>
      )}

      {toast && (
        <Toast
          message={toast.message}
          type={toast.type}
          duration={toast.duration}
          onClose={() => setToast(null)}
        />
      )}
    </>
  );
};

export default VendorAccess;
